import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useCreateUser } from "../../api/users";
import { useToast } from "../../components/ToastProvider";

const ROLES: Array<{ value: "ADMIN" | "FINANCEIRO" | "SUPORTE" | "LEITURA"; label: string }> = [
  { value: "ADMIN", label: "Administrador" },
  { value: "FINANCEIRO", label: "Financeiro" },
  { value: "SUPORTE", label: "Suporte" },
  { value: "LEITURA", label: "Leitura" },
];

export function NewUserModal({ show, onClose }: { show: boolean; onClose: () => void }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState<"ADMIN" | "FINANCEIRO" | "SUPORTE" | "LEITURA">("SUPORTE");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const create = useCreateUser();
  const toast = useToast();

  function reset() {
    setName("");
    setEmail("");
    setRole("SUPORTE");
    setPassword("");
    setError(null);
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return setError("Informe o nome.");
    if (!email.trim()) return setError("Informe o e-mail.");
    if (password.length < 8) return setError("A senha precisa ter pelo menos 8 caracteres.");

    try {
      await create.mutateAsync({ name, email, role, password });
      toast("Usuário criado.");
      reset();
      onClose();
    } catch {
      setError("Não foi possível criar o usuário — o e-mail já pode estar em uso.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show={show} onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Novo usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              Nome
            </label>
            <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              E-mail
            </label>
            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="row g-3">
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12 }}>
                Papel
              </label>
              <select className="form-select" value={role} onChange={(e) => setRole(e.target.value as typeof role)}>
                {ROLES.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12 }}>
                Senha inicial
              </label>
              <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={create.isPending}>
            Criar usuário
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
